import { useContext } from 'react';
import { AuthContext, AuthContextType } from './AuthContext';
import { PPAuthContext, PPAuthContextType } from './PlayerPortal';
import { AUTH_CONTEXT_KEYS } from '../utils';

export type AuthContextKey =
  (typeof AUTH_CONTEXT_KEYS)[keyof typeof AUTH_CONTEXT_KEYS];

export function useAuthContext(): AuthContextType;
export function useAuthContext(
  key: typeof AUTH_CONTEXT_KEYS.AUTH_CONTEXT_KEY,
): AuthContextType;
export function useAuthContext(
  key: typeof AUTH_CONTEXT_KEYS.PP_CONTEXT_KEY,
): PPAuthContextType;
export function useAuthContext(
  key: AuthContextKey,
): AuthContextType | PPAuthContextType;
export function useAuthContext(
  key: AuthContextKey = AUTH_CONTEXT_KEYS.AUTH_CONTEXT_KEY,
): AuthContextType | PPAuthContextType {
  const authContext = useContext(AuthContext);
  const ppContext = useContext(PPAuthContext);

  const authContextMap = {
    [AUTH_CONTEXT_KEYS.AUTH_CONTEXT_KEY]: authContext,
    [AUTH_CONTEXT_KEYS.PP_CONTEXT_KEY]: ppContext,
  } as const;

  const context = authContextMap[key];

  if (!context) {
    throw new Error(`useAuthContext must be used within ${key} provider`);
  }

  return context;
}
